export default {
    User: {
        setInfo: 'SET_USER',
        setToken: 'SET_TOKEN',
        setRole: 'SET_ROLE',
        setRoleShow: 'SET_ROLE_SHOW',
        saveAccount: 'SAVE_ACCOUNT',
    },
    Device: {
        set: 'SET_DEVICE',
    },
    TabBar: {
        setTabBar: 'SET_TAB_BAR',
        setInnerTabBar: 'SET_INNER_TAB_BAR'

    },
    AlivePage: {
        setAlivePage: 'SET_ALIVE_PAGE',
    },
    Page: {
        next: 'SET_NEXT',
        setFrom: 'SET_FROM',
        tatName: 'SET_TAT_NAME',
        currentOrgDetail: 'SET_CURRENT_ORG_DETAIL'
    },
    Reload: {
        chnRateList: 'RELOAD_CHN_RATE_LIST',
        appAreaList: 'RELOAD_APP_AREA_LIST',
        tatNameList: 'RELOAD_TAT_NAME_LIST',
        page: 'RELOAD_PAGE',
        isLoading: 'RELOAD_ISLOADING',
        basicInfoFlag: 'BASIC_INFO_FLAG',
    },
    perm: {
        setBtnPerm: 'SET_BTN_PERM'
    }
};



// WEBPACK FOOTER //
// ./src/store/interfaces.js